import React, { Component } from 'react'
import Swal from 'sweetalert2';
import { subUserById, subUserCreate, subUserUpdate } from '../../action/auth';
import UserCreate from '../../old_Components/ManageSubusers/UserCreate'
import constant from '../../constant'
export default class UserUpdate extends Component {
    constructor(props){
            super(props);
            this.state = {
              id:'',
              details:null
            }
    }

    componentDidMount(){
        document.title = constant.title.UserCreate
        this.getSubUserById()
      }
    
      getSubUserById = () => {
        const id=this.props.match.params?.id
        if(id){
          subUserById({id:id})
          .then((res) => {
            if (res.status) {
              this.setState({ details: res.result });
            }
          })
          .catch((error) => {
            alert(error);
          }); 
        }
      };

    onSubmit = (data) =>{
        subUserUpdate(data).then((res) => {
          if (res.status) {
            Swal.fire({
              icon: "success",
              text: "Sub user updated successfully",
              timer: 1500,
              showCancelButton: false,
              showConfirmButton: false
            });
            this.props.history.push(constant.component.UserList.url);
          } else {
            Swal.fire({
              icon: "error",
              text: res.error,
              timer: 1500,
              showCancelButton: false,
              showConfirmButton: false
            });
          }
      })
     
    }

  render() {
    return (
      <React.Fragment>
        {
            this.state.details &&
            <UserCreate onSubmit={(data)=>this.onSubmit(data)} id={this.props.match?.params?.id} details={this.state.details}/>
        }
        
      </React.Fragment>
    )
  }
}
